// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paywall-outer-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.paywall-outer-container h2 {
    margin: 5px 0;
}

.packages-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.package-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    gap: 30px;
}

.package-column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    min-width: 60px;
}

.upgrade-button {
    height: 2rem;
    flex: 0 0 auto;
}

.watch-ad-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.horizontal-separator {
    height: 1px;
    background-color: lightgray;
    margin: 10px 0;
}

.paywall-grouping {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.paywall-grouping * {
    margin: 0;
}

.inline-separator {
  display: flex;
  align-items: center;
  text-align: center;
  /* margin: 1.25rem 0 1rem; */
  color: var(--secondary-text-color);
  font-size: 0.9rem;
  width: 100%;
}

.inline-separator::before,
.inline-separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid var(--secondary-text-color);
}

.inline-separator:not(:empty)::before {
  margin-right: .75rem;
}

.inline-separator:not(:empty)::after {
  margin-left: .75rem;
}`, "",{"version":3,"sources":["webpack://./src/Paywall.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,kCAAkC;EAClC,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,OAAO;EACP,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".paywall-outer-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n.paywall-outer-container h2 {\n    margin: 5px 0;\n}\n\n.packages-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n.package-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-evenly;\n    gap: 30px;\n}\n\n.package-column {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    min-width: 60px;\n}\n\n.upgrade-button {\n    height: 2rem;\n    flex: 0 0 auto;\n}\n\n.watch-ad-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.horizontal-separator {\n    height: 1px;\n    background-color: lightgray;\n    margin: 10px 0;\n}\n\n.paywall-grouping {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n.paywall-grouping * {\n    margin: 0;\n}\n\n.inline-separator {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  /* margin: 1.25rem 0 1rem; */\n  color: var(--secondary-text-color);\n  font-size: 0.9rem;\n  width: 100%;\n}\n\n.inline-separator::before,\n.inline-separator::after {\n  content: \"\";\n  flex: 1;\n  border-bottom: 1px solid var(--secondary-text-color);\n}\n\n.inline-separator:not(:empty)::before {\n  margin-right: .75rem;\n}\n\n.inline-separator:not(:empty)::after {\n  margin-left: .75rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
